import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'
import NotFound from './NotFound'
import TravelPackageList from './Insurance/TravelPackageList'
import TicketPackageList from './Insurance/TicketPackageList'

const subList = {
  TravelPackageList: <TravelPackageList />,
  TicketPackageList: <TicketPackageList />
}

const SubComponent = ({subname = 'list'}) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound />
  }
}

const InsurancePage = ({location, match}) => <SubComponent subname={match.params.sub} location={location} />

export default InsurancePage



// WEBPACK FOOTER //
// ./src/Pages/InsurancePage.js